import z from "zod";

export const ecmSchema = z.object({
  articleFeeds: z.string().optional(),
  articles: z.string().optional(),
  dataFeeds: z.string().optional(),
  showArticleBlock: z.boolean().optional(),
});
